import { combineReducers } from "redux";

import control from "./control";
import getAvatar from "./getAvatar";
import getSignature from "./getSignature";
import getBankInformation from "./getBankInformation";
import getWorkInformation from "./getWorkInformation";
import getBasicInformation from "./getBasicInformation";
import getMaritalInformation from "./getMaritalInformation";
import getLanguageInformation from "./getLanguageInformation";
import getResidenceInformation from "./getResidenceInformation";
import getEducationInformation from "./getEducationInformation";
import getCertificationInformation from "./getCertificationInformation";
import formEditBankInformation from "./formEditBankInformation";
import formEditMaritalInformation from "./formEditMaritalInformation";
import formEditBasicInformation from "./formEditBasicInformation";
import workPerformanceResult from "./getWorkPerformanceResult";
import formEditEducationInformation from "./formEditEducationInformation";
import formEditResidenceInformation from "./formEditResidenceInformation";
import postFormEditPersonalInformation from "./postFormEditPersonalInformation";
import getHistoryTimeline from "./getHistoryTimeline";
import getHistoryDetail from "./getHistoryDetail";
import getPermissionEdit from "./getPermissionEdit";
import uploadFile from "./uploadFile";
import getCertificationProfessional from "./getCertificationProfessional";

const personnelInformationReducer = combineReducers({
  control,
  getAvatar,
  getSignature,
  getBankInformation,
  getWorkInformation,
  getBasicInformation,
  getMaritalInformation,
  getLanguageInformation,
  getResidenceInformation,
  getEducationInformation,
  getCertificationInformation,
  formEditBankInformation,
  formEditMaritalInformation,
  formEditBasicInformation,
  workPerformanceResult,
  formEditEducationInformation,
  formEditResidenceInformation,
  postFormEditPersonalInformation,
  getHistoryTimeline,
  getHistoryDetail,
  uploadFile,
  getPermissionEdit,
  getCertificationProfessional,
});

export default personnelInformationReducer;
